import { Session } from '@ais-ui/auth';

interface InitEnableMFAResponse {
  secret: string;
}

export const initEnableMFA = async (
  session: Session,
  userName: string,
  password: string
): Promise<InitEnableMFAResponse> => {
  const response = await session.request('initEnableMFA', {
    userName,
    password,
  });

  return response;
};
